import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {api} from '../lib/api'
import {router} from '../lib/router'

Vue.use(Vuex)

var decodeToken = token => {
	let split = token.split('.')
	return JSON.parse(window.atob(split[1]))
}

export const store = new Vuex.Store({
	state: {
		env: '',
		debug: false,
		token: null,
		user: null,
		tokenReadTime: '',
		loginStatus: '',
		dialogConfirm: {
			open: false,
			title: '',
			message: '',
			btnAcceptText: '',
			btnDenyText: ''
		},
		dialogNotify: {
			open: false,
			title: '',
			message: '',
			duration: 0,
			btnAcceptText: '',
		},
		dialogLoading: {
			open: false
		},
		dialogDone: {
			open: false,
			message: '',
			duration: 1000,
			messageClass: ''
		},
		selectedHotelCode: '',
		pathBeforeLogin: '',
	},
	getters: {
		allHotels: state => (state.user && state.user.ho ? state.user.all_hotels : null),
		availableHotels: state => (state.user ? (state.user.ho ? state.user.all_hotels : state.user.hotels) : null),
		debug: state => state.debug,
		dialogConfirm: state => state.dialogConfirm,
		dialogNotify: state => state.dialogNotify,
		dialogLoading: state => state.dialogLoading,
		dialogDone: state => state.dialogDone,
		env: state => state.env,
		isDemo: state => (state.user ? state.user.demo : null),
		loggedIn: state => !!state.token,
		loginStatus: state => state.loginStatus,
		pathBeforeLogin: state => state.pathBeforeLogin,
		prefLan: state => (state.user ? (state.user.preferences ? state.user.preferences.lan : 'ru') : 'ru'),
		selectedHotelCode: state => state.selectedHotelCode,
		tokenReadTime: state => state.tokenReadTime,
		userId: state => (state.user ? state.user.id : ''),
		userName: state => (state.user ? state.user.fullName : ''),
		userHotels: state => (state.user ? state.user.hotels : null),
		userDepts: state => (state.user ? state.user.depts : null),
		userHo: state => (state.user ? state.user.ho : null),
		userHasRight: state => right => {
			if (state.user && state.user.rights) return state.user.rights.indexOf(right) != -1
			else return false
		},
		userHasRoleCode: state => code => {
			if (state.user && state.user.roleCodes) return state.user.roleCodes.indexOf(code) != -1
			else return false
		},
		userHasHotel: state => hotelCode => {
			if (state.user && state.user.hotels) return !!state.user.hotels.find(el => el.code == hotelCode)
			else return false
		},
	},
	mutations: {
		authLoading(state) {
			state.loginStatus = 'loading'
		},
		authSuccess(state, token) {
			if (state.debug) console.log('store mutation - authSuccess')
			state.loginStatus = 'success'
			state.token = token
			state.user = decodeToken(state.token.access).user
			localStorage.setItem('token_access', token.access)
			localStorage.setItem('token_refresh', token.refresh)
			localStorage.setItem('token_exp', token.exp)
			axios.defaults.headers.common['authorization'] = token.access
			axios.defaults.headers.common['x-refresh'] = token.refresh

			let path = state.pathBeforeLogin

			if (path.length > 0) {
				router.push(path)
				state.pathBeforeLogin = ''
			}
			else {
				router.push('/')
			}
		},
		authLogout(state) {
			if (state.debug) console.log('store mutation - authLogout')

			state.loginStatus = '';
			state.token = null;
			state.user = null;
			localStorage.removeItem('token_access');
			localStorage.removeItem('token_refresh');
			localStorage.removeItem('token_exp');
			delete axios.defaults.headers.common['authorization'];
			delete axios.defaults.headers.common['x-refresh'];
			// state.pathBeforeLogin = router.currentRoute.path
			router.push('/login');
		},
		authFailure(state, error) {
			if (state.debug) console.log('store mutation - authFailure')
			if (state.debug) console.log(error)
			if (error == 'Restricted') {
				state.loginStatus = 'restricted'
			}
			else {
				state.loginStatus = 'error'
			}
			state.token = null
			state.user = null
			localStorage.removeItem('token_access')
			localStorage.removeItem('token_refresh')
			localStorage.removeItem('token_exp')
			delete axios.defaults.headers.common['authorization']
			delete axios.defaults.headers.common['x-refresh']
			if (router.currentRoute.path != '/login') {
				router.push('/login')
			}
		},
		getTokenFromStorage(state) {
			if (state.debug) console.log('store mutation - getTokenFromStorage')

			if (localStorage.getItem('token_access')
				&& localStorage.getItem('token_refresh')
				&& localStorage.getItem('token_exp')
			) {
				if (state.debug) console.log('-- token found in localStorage')

				state.token = {
					access: localStorage.getItem('token_access'),
					refresh: localStorage.getItem('token_refresh'),
					exp: localStorage.getItem('token_exp')
				}
				state.tokenReadTime = Math.floor(Date.now() / 1000)
				state.user = decodeToken(state.token.access).user;
				axios.defaults.headers.common['authorization'] = state.token.access;
				axios.defaults.headers.common['x-refresh'] = state.token.refresh;
			}
			else {
				if (state.debug) console.log('-- token not found')

				state.token = null
				state.user = null
				delete axios.defaults.headers.common['authorization']
				delete axios.defaults.headers.common['x-refresh']
			}
		},
		getSelectedHotelCodeFromStorage(state) {
			if (state.debug) console.log('store mutation - getSelectedHotelCodeFromStorage')

			let selHotelCode = localStorage.getItem('selected_hotel_code')

			if (selHotelCode
				&& state.user
				&& (state.user.ho || (state.user.hotels && state.user.hotels.find(el => el.code == selHotelCode)))
			) {
				state.selectedHotelCode = selHotelCode
			}
			else {
				state.selectedHotelCode = ''
				localStorage.setItem('selected_hotel_code', '')
			}
		},
		setDialogDone(state, dialog) {
			state.dialogDone = Object.assign(state.dialogDone, dialog)
		},
		setDialogLoading(state, dialog) {
			state.dialogLoading = Object.assign(state.dialogLoading, dialog)
		},
		setDialogNotify(state, dialog) {
			state.dialogNotify = Object.assign(state.dialogNotify, dialog)
		},
		setDialogConfirm(state, dialog) {
			state.dialogConfirm = Object.assign(state.dialogConfirm, dialog)
		},
		setEnviroment(state, env) {
			state.env = env
		},
		setPathBeforeLogin(state, path) {
			state.pathBeforeLogin = path
		},
		setPreferences(state, preferences) {
			state.user.preferences = preferences
		},
		setSelectedHotelCode(state, hotelCode) {
			state.selectedHotelCode = hotelCode
			localStorage.setItem('selected_hotel_code', hotelCode)
		},
		updateToken(state, token) {
			if (state.debug) console.log('store mutation - updateToken')
			state.loginStatus = 'success';
			state.token = token;
			state.user = decodeToken(state.token.access).user;
			localStorage.setItem('token_access', token.access);
			localStorage.setItem('token_refresh', token.refresh);
			localStorage.setItem('token_exp', token.exp);
			axios.defaults.headers.common['authorization'] = token.access;
			axios.defaults.headers.common['x-refresh'] = token.refresh;
		},
	},
	actions: {
		destroyToken(context) {
			if (context.getters.debug) console.log('store action - destroyToken')

			if (context.getters.loggedIn) {
				return new Promise((resolve, reject) => {

					axios.post(api.path() + 'auth/logout', {
						token: context.state.token.refresh,
						user_id: context.state.user.id
					})
					.then(response => {

						if (context.getters.debug) console.log('-- logout')
						context.commit('authLogout');
						resolve(response);
					})
					.catch(error => {

						if (context.getters.debug) console.log('-- logout')
						context.commit('authLogout');

						// написать логику для error

						reject(error);
					})
				});
			}
		},
		dialogConfirm(context, dialog) {
			dialog.open = true
			dialog.title = dialog.title || ''
			dialog.message = dialog.message || ''
			dialog.btnAcceptText = dialog.btnAcceptText || 'Ок'
			dialog.btnDenyText = dialog.btnDenyText || 'Назад'

			context.commit('setDialogConfirm', dialog)

			return new Promise((resolve, reject) => {
				this.dialogConfirmResolve = resolve
				this.dialogConfirmReject = reject
			})
		},
		dialogConfirmAccept(context) {
			this.dialogConfirmResolve(true)
			context.commit('setDialogConfirm', {
				open: false,
				title: '',
				message: ''
			})
		},
		dialogConfirmDeny(context) {
			this.dialogConfirmResolve(false)
			context.commit('setDialogConfirm', {
				open: false,
				title: '',
				message: ''
			})
		},
		dialogDone(context, dialog) {
			dialog = dialog || {}
			dialog.open = true
			dialog.message = dialog.message || ''
			dialog.duration = dialog.duration || 1000
			if (dialog.message.length) {
				dialog.messageClass = 'xs' + Math.min(Math.round((dialog.message.length + 2) / 2.5), 10)
			}

			context.commit('setDialogDone', dialog)

			setTimeout(() => {
				context.commit('setDialogDone', {
					open: false,
					message: '',
					messageClass: ''
				})
			}, dialog.duration)
		},
		dialogLoadingStart(context) {
			context.commit('setDialogLoading', {
				open: true
			})
		},
		dialogLoadingStop(context) {
			context.commit('setDialogLoading', {
				open: false
			})
		},
		dialogNotify(context, dialog) {
			dialog.open = true
			dialog.title = dialog.title || ''
			dialog.message = dialog.message || ''
			dialog.duration = dialog.duration || 0
			dialog.btnAcceptText = dialog.btnAcceptText || 'Ок'

			context.commit('setDialogNotify', dialog)

			if (dialog.duration > 0) {
				setTimeout(() => {
					this.dispatch('dialogNotifyHide')
				}, dialog.duration)
			}

			return new Promise((resolve, reject) => {
				this.dialogNotifyResolve = resolve
				this.dialogNotifyReject = reject
			})
		},
		dialogNotifyHide(context) {
			this.dialogNotifyResolve(true)
			context.commit('setDialogNotify', {
				open: false,
				title: '',
				message: ''
			})
		},
		loadMenuCounters(context) {
			// console.log('loadMenuCounters')

			if (store.getters.userHasRight('pr_view')) {
				api.post('pr/get_list', { getCount: true })
				.then(response => {
					this.dispatch('setCounterPr', response.data.count)
				}, error => {})
			}
			if (store.getters.userHasRight('po_view')) {
				api.post('po/get_list', { getCount: true })
				.then(response => {
					this.dispatch('setCounterPo', response.data.count)
				}, error => {})
			}
			if (store.getters.userHasRight('mm_view')) {
				api.post('mm/get_list', { getCount: true })
				.then(response => {
					this.dispatch('setCounterMm', response.data.count)
				}, error => {})
			}

			// api.all([
			// 	api.post('pr/get_list', { getCount: true }),
			// 	api.post('po/get_list', { getCount: true }),
			// 	api.post('mm/get_list', { getCount: true })
			// ])
			// .then(api.spread((responsePr, responsePo, responseMm) => {
			// 	this.dispatch('setCounterPr', responsePr.data.count)
			// 	this.dispatch('setCounterPo', responsePo.data.count)
			// 	this.dispatch('setCounterMm', responseMm.data.count)
			// }), error => {})

		},
		readToken(context) {
			if (context.getters.debug) console.log('store action - readToken')

			context.commit('getTokenFromStorage')

			context.commit('getSelectedHotelCodeFromStorage')

			if (context.getters.loggedIn) {

				api.post(api.path() + 'auth/check_access')
				.then(response => {}, error => {})
			}
		},
		retrieveToken(context, credentials) {
			if (context.getters.debug) console.log('store action - retrieveToken')

			return new Promise((resolve, reject) => {
				context.commit('authLoading');

				axios.post(api.path() + 'auth/login', {
					username: credentials.username,
					password: credentials.password
				})
				.then(response => {
					if (context.getters.debug) console.log(response)
					if (response.data.success) {
						const token = response.data.token;
						context.commit('authSuccess', token);
					}
					else {
						context.commit('authFailure', response.data.error);
					}

					resolve(response);
				})
				.catch(error => {
					if (context.getters.debug) console.log('-- logout')
					context.commit('authLogout');
					reject(error);
				})
			});
		},
		setEnviroment(context) {
			if (context.getters.debug) console.log('store action - setEnviroment')

			let origin = window.location.origin

			if (origin == 'http://localhost:8080'
				|| new RegExp('https?:\/\/dev-reports.ifk-hm.(com|ru)').test(origin)
			) {
				// development
				context.commit('setEnviroment', 'development')
			}
			else if (new RegExp('https?:\/\/reports.ifk-hm.(com|ru)').test(origin)) {
				// production
				context.commit('setEnviroment', 'production')
			}
			else {
				console.error('Store error - Unknown enviroment')
			}
		},
		setCounterPo(context, count) {
			router.options.routes.find(r => r.name == 'PoList').meta.count = count
		},
		setCounterPr(context, count) {
			router.options.routes.find(r => r.name == 'PrList').meta.count = count
		},
		setCounterMm(context, count) {
			router.options.routes.find(r => r.name == 'MmList').meta.count = count
		},
		setPathBeforeLogin(context, path) {
			if (context.getters.debug) console.log('store action - setPathBeforeLogin')

			context.commit('setPathBeforeLogin', path)
		},
		setPreferences(context, preferences) {
			context.commit('setPreferences', preferences)
		},
		setSelectedHotelCode(context, hotelCode) {
			context.commit('setSelectedHotelCode', hotelCode)
		},
	}
})
